import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'QrcodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-qrcode",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 17l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 7l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 7l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 14l3 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 14l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 14l0 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 20l3 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 17l3 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 17l0 3"
    }, null), _createTextVNode(" ")]);
  }
};